module.exports = __webpack_public_path__ + "media/images/icon_edit-1d4f6fdff49a5d7354a2b03e934967bf.svg";